<template>
    <article class="card__sc" :data-ba-i="view.name">
        <div class="backdropp" v-if="backgroundActive"></div>
        <div class="topper">
            <div class="infos" @click="handleClickCard(view.hash)">
                <img class="infos__user__ico" :src="view.producer.gravatar" />
                <div class="infos__user">
                    <h2 v-html="view.name" :title="view.name"></h2>
                    <h3>
                        <span v-html="t.label_created_by"></span>
                        <span v-html="view.producer.name"></span>
                    </h3>
                </div>
            </div>
            <div class="dots" @mouseenter="backgroundActive = true" @mouseleave="backgroundActive = false">
                <svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM14 0C12.9 0 12 0.9 12 2C12 3.1 12.9 4 14 4C15.1 4 16 3.1 16 2C16 0.9 15.1 0 14 0ZM8 0C6.9 0 6 0.9 6 2C6 3.1 6.9 4 8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 0 8 0Z" fill="black"/>
                </svg>
                <div class="items__dots">
                    <span @click="handleClickCard(view.hash)" v-html="t.label_details"></span>
                    <span @click="handleClickCard(view.hash)" v-html="t.label_links"></span>
                    <span @click="handleClickCard(view.hash)" v-html="t.label_contact"></span>
                </div>
            </div>
        </div>
        <div class="banner_out">
            <img @click="handleClickCard(view.hash)" class="banner" :style="`background-image: url('${(view.versions[view.versions.length-1].image ? view.versions[view.versions.length-1].image.url : '/internacional/public/office4/img/supercheckout-intern/ic-placeholder.png')}')`" />
        </div>
        <div class="fotter" @click="handleClickCard(view.hash)">
            <div class="first">
                <span v-html="t.label_commission_until"></span>
                <span v-text="handleValue(view.versions[view.versions.length-1].currency, view.versions[view.versions.length-1].total, view.versions[view.versions.length-1].config_affiliation.level1)"></span>
                <div class="graphic">
                    <span :style="{ width: `40%` }"></span>
                </div>
            </div>
            <div class="second">
                <div class="temperature">100°</div>
                <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.50009 15.9999H20.5001V17.9999H1.50009V15.9999ZM21.0701 6.63995C20.8601 5.83995 20.0301 5.35995 19.2301 5.57995L13.9201 6.99995L7.02009 0.569946L5.09009 1.07995L9.23009 8.24995L4.26009 9.57995L2.29009 8.03995L0.840088 8.42995L2.66009 11.5899L3.43009 12.9199L5.03009 12.4899L10.3401 11.0699L14.6901 9.90995L20.0001 8.48995C20.8101 8.25995 21.2801 7.43995 21.0701 6.63995Z" fill="#14C51B"/>
                </svg>
            </div>
        </div>
    </article>
</template>

<script>
export default {
    name: "super-checkout-intern-card",
    props: ["view"],
    data(){
        return {
            t: this.$parent.view.translation,
            backgroundActive: false,
        }
    },
    mounted () {
        // console.log('card',this.$parent.view.translation);
    },

    methods: {
        handleClickCard(hash) {
            this.$parent.showModalCardSelected = true;
            this.$parent.modalCardSelectedID = hash;
            setTimeout(() => {
                let modal = document.querySelector('#cardDocumentModal');
                let body = document.querySelector('body');
                body.appendChild(modal);
            }, 150);

        },
        handleOptionsCard() {
            // console.log('fire');
        },
        handleValue(currency, value, comission) {
            if(currency == 'USD') return this.handlePercentage(value, 80, comission, currency);
            if(currency == 'BRL') return this.handlePercentage(value, 90, comission, currency);
            if(currency == 'EUR') return this.handlePercentage(value, 100, comission, currency);
        },
        handlePercentage(value, percentage, comission, currency) {
            return `${currency} ${(((((value / 100) * percentage) / 100) * comission) / 100).toFixed(2)}`;
        }
    },

    computed: {
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.backdropp {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: black;
    opacity: 0.5;
}
.card__sc {
    background: #FFFFFF;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    padding: 1rem 0;
    cursor: pointer;
    transition: .2s all;
    &:hover {
        // transform: scale(1.01);
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);
    }
    .topper {
        display: flex;
        justify-content: space-around;
        align-items: flex-start;
        min-height: 80px;
        .infos {
            display: flex;
            align-items: center;
            .infos__user__ico {
                margin: 0 .4rem;
                width: 36px;
                border-radius: 30px;
            }
            .infos__user {
                display: flex;
                flex-direction: column;
                h2,
                h3 {
                    margin: 0;
                    color: #5B5B5B;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                h2 {
                    font-size: 1.08rem;
                    font-weight: 600;
                }
                h3 {
                    font-size: .78rem;
                    margin-top: .4rem;
                    span {
                        font-size: 1em;
                        font-weight: 300;
                        &:first-child {
                            color: #C6C2C2;
                        }
                    }
                }
            }
        }
        .dots {
            padding: 0 1rem 1rem 1rem;
            position: relative;
            &:hover {
                .items__dots {
                    display: block;
                }
            }
            .items__dots {
                position: absolute;
                left: -40px;
                margin: 0 auto;
                background: #FFFFFF;
                border-radius: 4px;
                padding: .35rem 0;
                display: none;
                span {
                    display: block;
                    padding: .8rem 2rem;
                    transition: .14s all ease;
                    font-weight: 600;
                    &:hover {
                        background: rgba(196, 196, 196, 0.15);
                        color: #0080FC;
                    }
                }
            }
        }
    }
    .banner_out {
        margin-bottom: 1rem;
        text-align: center;
        .banner {
            height: 290px;
            width: 290px;
            background-size: cover;
        }
    }
    .fotter {
        display: flex;
        padding: 0 1rem;
        justify-content: space-between;
        .first {
            display: flex;
            flex-direction: column;
            span {
                font-size: .88rem;
                &:nth-child(1) {
                    color: #434343;
                }
                &:nth-child(2) {
                    font-size: 1.1em;
                    color: #14C51B;
                    font-weight: 600;
                    margin: .2rem 0;
                }
            }
            .graphic {
                width: 100%;
                background: #E5E5E5;
                border-radius: 1px;
                height: 13px;
                span {
                    display: block;
                    height: 100%;
                    border-radius: 1px;
                    background: #14C51B;
                }
            }
        }
        .second {
            display: flex;
            align-items: center;
            .temperature {
                background: #C4C4C4;
                color: white;
                border-radius: 3px;
                padding: .4rem 1.3rem;
                margin-right: .7rem;
                font-weight: 600;;
            }
        }
    }
}
@media (max-width: 800px) {
    .card__sc .topper {
        padding: 0 1rem;
        justify-content: space-between;
    }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/super-checkout-intern/card.vue